<script lang="ts">
  import ModalSimple from '$components/modal/ModalSimple.svelte';
  import Button from '$components/button/Button.svelte';
  import { closeModal } from '$components/bottom-sheet/index.svelte';
  import { stateEnvioEndpoint } from '$states/envioEndpoint.svelte';
  import InputText from '$components/input-text/InputText.svelte';

  let endpoint = $state<string>('');

  const confirm = async (): Promise<void> => {
    stateEnvioEndpoint.change(endpoint);
    closeModal();
  };
</script>

<ModalSimple>
  {#snippet title()}
    Switch Envio Endpoint
  {/snippet}
  {#snippet paragraph()}
    Enter deployment endpoint here:
    <div class="relative z-20">
      <InputText bind:value={endpoint} name="endpoint" placeholder="eaaf4e6"></InputText>
    </div>
  {/snippet}
  {#snippet action()}
    <Button ariaLabel="Confirm" variant="success" onclick={confirm}>Confirm</Button>
    <Button ariaLabel="Cancel" variant="secondary" onclick={() => closeModal()}>Cancel</Button>
  {/snippet}
</ModalSimple>
